// Módulos contratados por organização (condominiums.enabled_modules).
// Mesma semântica da licença desktop: "full_itacondo" é a suíte completa e
// inclui controle de acesso e ponto eletrônico.

export type AppModule = "access_control" | "time_clock" | "full_itacondo"

export type OrgType = "condominio" | "ponto_eletronico" | "controle_acessos"

export const ALL_MODULES: AppModule[] = ["full_itacondo", "access_control", "time_clock"]

export const MODULE_META: Record<AppModule, { label: string; short: string; description: string }> = {
  full_itacondo: {
    label: "Condomínio (suíte completa)",
    short: "Condomínio",
    description: "Moradores, unidades, encomendas, financeiro, áreas comuns. Inclui acesso e ponto.",
  },
  access_control: {
    label: "Controle de acesso",
    short: "Acesso",
    description: "Visitantes, portaria, destinos e colaboradores.",
  },
  time_clock: {
    label: "Ponto eletrônico",
    short: "Ponto",
    description: "Registro de ponto, folhas e banco de horas.",
  },
}

export const ORG_TYPE_PRESET: Record<OrgType, AppModule[]> = {
  condominio: ["full_itacondo"],
  ponto_eletronico: ["time_clock"],
  controle_acessos: ["access_control"],
}

const isAppModule = (value: unknown): value is AppModule =>
  value === "access_control" || value === "time_clock" || value === "full_itacondo"

/** Módulos de uma organização; sem a coluna (migração pendente), cai no preset do tipo. */
export const resolveOrgModules = (org: { enabled_modules?: unknown; type?: string | null } | null | undefined): AppModule[] => {
  if (!org) return []
  const raw = Array.isArray(org.enabled_modules) ? org.enabled_modules.filter(isAppModule) : []
  if (raw.length > 0) return Array.from(new Set(raw))
  return ORG_TYPE_PRESET[(org.type as OrgType) ?? "condominio"] ?? ORG_TYPE_PRESET.condominio
}

export const moduleIncluded = (modules: readonly AppModule[], module: AppModule) =>
  modules.includes("full_itacondo") || modules.includes(module)

/** Normaliza a seleção: com a suíte completa, os demais ficam implícitos. */
export const normalizeModuleSelection = (modules: readonly AppModule[]): AppModule[] =>
  modules.includes("full_itacondo") ? ["full_itacondo"] : ALL_MODULES.filter((m) => modules.includes(m))
